import React from "react";
import PropTypes from "prop-types";

import IconCheckmark from "../icons/Checkmark";

const ChecklistItem = ({ content, checkmarkColor, classNames }) => (
  <li className={`checkmark ${classNames ? classNames.join(" ") : ""}`}>
    <IconCheckmark color={checkmarkColor} />
    {content}
  </li>
);

ChecklistItem.propTypes = {
  content: PropTypes.string.isRequired,
  checkmarkColor: PropTypes.string,
  classNames: PropTypes.array,
};

export default ChecklistItem;
